module.exports = __webpack_public_path__ + "img/img8.c42041e6.svg";